module.exports = __webpack_public_path__ + "img/504.1fc8530.png";